module.exports = __webpack_public_path__ + "img/image04.1651141d.jpg";